import * as React from "react";
import { Routes, Route, Link } from "react-router-dom";
import "./App.css";
import Navbar from './components/Navbar'
import Home from './components/pages/Home'
import Contact from './components/pages/Contact'
import Products from './components/pages/Products'

export default function App() {
  return (
    <div className="App">
     <Navbar/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Products" element={<Products />} />
        <Route path="/Contact" element={<Contact />} />

      </Routes>
    </div>
  );
}